import type { Reducer } from 'redux';

import type { AnalyticsState } from './analyticsTypes';

export const initialState: AnalyticsState = {
  keyIndicatorsData: null,
};

const analyticsReducer: Reducer<AnalyticsState> = (state = initialState) => {
  return state;
};

export default analyticsReducer;
